<template>
    <span v-if="!deletedAt" class="inline-flex leading-5 font-semibold rounded-full">
        <span
            :class="[
                badgeClasses,
                'rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset',
                variant === 'hero' ? 'backdrop-blur' : '',
            ]"
        >
            {{ label }}
        </span>
    </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    tier: {
        type: Object,
        required: true,
    },
    deletedAt: {
        type: [String, null],
        default: null,
    },
    variant: {
        type: String,
        default: 'index',
        validator: (value) => ['index', 'hero'].includes(value),
    },
})

const label = computed(() => props.tier?.label ?? 'Basic Plan')
const badgeClasses = computed(() => {
    if (props.variant === 'hero') {
        return props.tier?.badge_classes ?? 'bg-slate-100 text-slate-600 ring-slate-400/40'
    }

    return props.tier?.index_badge_classes ?? 'bg-slate-100 text-slate-600 ring-slate-400/40'
})
</script>
